module.exports = __webpack_public_path__ + "img/index_xf.e2349709.png";